import { render, staticRenderFns } from "./new-request.modal.vue?vue&type=template&id=3e319182&scoped=true"
import script from "./new-request.modal.vue?vue&type=script&lang=js"
export * from "./new-request.modal.vue?vue&type=script&lang=js"
import style0 from "./new-request.modal.vue?vue&type=style&index=0&id=3e319182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e319182",
  null
  
)

export default component.exports